import { CONTENT } from './content';

const ALIM_CATS = ['ble_cereales','sucre','huiles_vegetales','viandes','lait_produits_laitiers','cafe_the','chocolat_confiserie','poissons','fruits_legumes','epices','conserves','boissons','pates_alimentaires','riz','legumineuses'];
const COSM_CATS = ['cosmetiques'];

export function getEtiquetageRules(categorie, lang = 'fr') {
  const c = CONTENT[lang] || CONTENT.fr;
  const rules = [
    { titre: c.etiq_arabe_title, obligatoire: true, description: c.etiq_arabe_desc, base_legale: c.etiq_arabe_loi },
    { titre: c.etiq_gtin_title, obligatoire: true, description: c.etiq_gtin_desc, base_legale: c.etiq_gtin_loi, exception: c.etiq_gtin_exception },
  ];

  if (ALIM_CATS.includes(categorie)) {
    rules.push({ titre: c.etiq_alim_title, mentions: c.etiq_alim_items, base_legale: c.etiq_alim_loi });
  } else if (COSM_CATS.includes(categorie)) {
    rules.push({ titre: c.etiq_cosm_title, mentions: c.etiq_cosm_items, base_legale: c.etiq_cosm_loi });
  } else {
    rules.push({ titre: c.etiq_non_alim_title, mentions: c.etiq_non_alim_items });
  }
  return rules;
}
